import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {ModelConfigurationComponent} from '@page/model-configuration/model-configuration.component';

@Injectable()
export class ModelConfigurationDeactivateGuard  {
  public component: any;
  public route: ActivatedRouteSnapshot | undefined;

  constructor(private router: Router) {
  }

  canDeactivate(component: ModelConfigurationComponent,
                route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot,
                nextState: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.router.currentNavigation()?.extras?.state?.bypassFormGuard) {
      return true;
    }

    return component.canExit(nextState);

  }

}
